import reportService from '../shared/services/reportService'
import { setLogout } from './authActions'

const REQUEST_REPORTS_LIST = 'REQUEST_REPORTS_LIST'
const RESPONSE_REPORTS_LIST = 'RESPONSE_REPORTS_LIST'
const REQUEST_REPORTS_LIST_FAILURE = 'REQUEST_REPORTS_LIST_FAILURE'

const requestReportsListAction = () => {
  return {
    type: REQUEST_REPORTS_LIST
  }
}

const responseReportsListAction = (data) => {
  return {
    type: RESPONSE_REPORTS_LIST,
    data
  }
}

const requestReportsListFailureAction = (errors) => {
  return {
    type: REQUEST_REPORTS_LIST_FAILURE,
    errors
  }
}

const getReportsList = () => {
  return (dispatch) => {
    dispatch(requestReportsListAction())

    reportService.getReportTypes()
      .then((result) => {
        dispatch(responseReportsListAction(result.data.reports))
      })
      .catch((error) => {
        dispatch(requestReportsListFailureAction(error.response))

        if (error.response && error.response.status === 401) {
          dispatch(setLogout())
        }
      })
  }
}

export {
  REQUEST_REPORTS_LIST,
  RESPONSE_REPORTS_LIST,
  REQUEST_REPORTS_LIST_FAILURE,
  requestReportsListAction,
  responseReportsListAction,
  requestReportsListFailureAction,
  getReportsList
}
